// extracted by mini-css-extract-plugin
module.exports = {"time_out_timer":"Timer_time_out_timer__25EDv","animation":"Timer_animation__2xUc1","showing":"Timer_showing__Z6-x_"};